import { batch, connect } from 'react-redux';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';

import { FilterList } from 'src/components/organisms/Filter/components/FilterList';
import {
  selectFilters,
  selectFiltersWithoutSortFilter,
  selectTotalActiveOptions,
  selectTotalFiltersApplied,
} from 'src/components/organisms/Filter/modules/selectors/selectors';
import { actions as filterActions } from 'src/components/organisms/Filter/modules/slice';
import { actions as filterMenuActions } from 'src/components/organisms/FilterMenu/modules/slice';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { updateFilters, UpdateFiltersActionType } from 'src/redux/products/thunks/updateFilters';
import type { AppThunkDispatch } from 'src/redux/store';
import type {
  FilterListContainerDispatchProps,
  FilterListContainerStateProps,
} from './FilterListContainer.types';

interface FilterListContainerProps {
  removeSortFilter?: boolean;
}

export const mapStateToProps = (
  state: ReduxApplicationState,
  { removeSortFilter }: FilterListContainerProps,
): FilterListContainerStateProps => ({
  error: state.products.error,
  filters: removeSortFilter
    ? // This is needed to remove the sort filter from the list when rendering the filters on large screen. Sort filter should only show on MW & TA.
      selectFiltersWithoutSortFilter(state)
    : selectFilters(state),
  isLoading: state.products.isLoading,
  totalFiltersApplied: selectTotalFiltersApplied(state),
  totalProducts: state.products.totalProducts,
  totalActiveOptions: selectTotalActiveOptions(state),
});

export const mapDispatchToProps = (
  dispatch: AppThunkDispatch,
): FilterListContainerDispatchProps => ({
  onAllFiltersVisible: () => {
    sendGAEvent({
      event: 'custom_event',
      event_category: 'Filters',
      event_action: 'filter impression',
      event_label: 'all filters viewed',
    });
  },
  onCloseFilters: () => dispatch(filterActions.closeModal()),
  onDeliveryFilterVisible: () => {
    sendGAEvent({
      event: 'custom_event',
      event_category: 'Filters',
      event_action: 'filter impression',
      event_label: 'delivery',
    });
  },
  onResetFilters: ({ totalFiltersApplied, totalActiveOptions }) => {
    batch(() => {
      dispatch(filterActions.resetFilters());
      dispatch(filterMenuActions.resetSelectedSortOption());
      dispatch(updateFilters(UpdateFiltersActionType.FILTER));
    });
    sendGAEvent({
      event: 'custom_event',
      event_category: 'Filters',
      event_action: 'reset all filters',
      event_label: `number of categories: ${totalFiltersApplied}|number of filters: ${totalActiveOptions}`,
    });
  },
  onViewResults: ({ totalFiltersApplied, totalActiveOptions }) => {
    sendGAEvent({
      event: 'custom_event',
      event_category: 'Filters',
      event_action: 'view results',
      event_label: `number of categories: ${totalFiltersApplied}|number of filters: ${totalActiveOptions}`,
    });

    dispatch(filterActions.closeModal());
  },
});

export const FilterListContainer = connect(mapStateToProps, mapDispatchToProps)(FilterList);
